import React, { useMemo, useState } from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { SearchInput } from "../../widgets";
import { searchWord } from "../../../helpers/common";

const FilterPipeDropDown = ({
  filterKey,
  options = [],
  selected,
  handleFilterChange,
  data,
  weightsKeys,
}) => {
  const [searchTexts, setSearchTexts] = useState({});
  const [prevSelectedOptions, setPrevSelectedOptions] = useState({});
  const checkUnknown = (name) =>
    typeof name === "string" && name.toLowerCase() === "unknown";

  const handleSearchChange = (key, text) => {
    setSearchTexts((prevState) => ({
      ...prevState,
      [key]: text,
    }));
  };

  const filteredDropDownList = useMemo(() => {
    if (!options || options.length === 0) return [];
    const filteredDropDown = [];

    options.forEach((item) => {
      if (checkUnknown(item)) {
        filteredDropDown.unshift(item);
      } else {
        filteredDropDown.push(item);
      }
    });

    const searchText = searchTexts[filterKey] || "";

    if (searchText.trim().length > 0) {
      return filteredDropDown.filter((item) => searchWord(item, searchText));
    }

    return filteredDropDown;
  }, [searchTexts, filterKey, options]);

  const handleCheckboxChange = (filterKey, option) => {
    const isChecked =
      selected[filterKey] && selected[filterKey].includes(option);

    if (isChecked) {
      const updatedPrevSelected = {
        ...prevSelectedOptions,
        [filterKey]: selected[filterKey].filter((opt) => opt !== option),
      };
      setPrevSelectedOptions(updatedPrevSelected);
    }

    handleFilterChange(filterKey, option);
  };

  return (
    <Dropdown className="filter-dropdown-container">
      <Dropdown.Toggle
        className="filter-dropdown-toggle"
        disabled={data.length === 0}
      >
        <i className="fa fa-filter filter-btn" title="Filter" />
        {selected && selected.length > 0 && (
          <Badge variant="warning" className="badge-filter-count">
            {selected.length}
          </Badge>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu align="right" className="networkStatus">
        <div className="mx-2 mb-1">
          {!weightsKeys.includes(filterKey) && (
            <SearchInput
              onChange={(text) => handleSearchChange(filterKey, text)}
            />
          )}
        </div>

        <div className={"filter-dropdown-menu-custom"}>
          {filteredDropDownList && filteredDropDownList.length > 0 ? (
            filteredDropDownList.map((option, index) => (
              <div
                key={`opt_${option}_${index}`}
                className="filter-dropdown-item-custom"
              >
                <label>
                  <span>
                    <input
                      type="checkbox"
                      checked={
                        (selected && selected && selected.includes(option)) ||
                        false
                      }
                      onChange={() => handleCheckboxChange(filterKey, option)}
                    />
                  </span>
                  <span className={`item-text ${option ? "" : "text-danger"}`}>
                    {option ? option : "Unknown"}
                  </span>
                </label>
              </div>
            ))
          ) : (
            <div className="text-sm-center my-3 font-weight-normal">
              No data found
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FilterPipeDropDown;